import { render, staticRenderFns } from "./CreateKnowledgeItemView.vue?vue&type=template&id=4441e78e&"
import script from "./CreateKnowledgeItemView.vue?vue&type=script&lang=js&"
export * from "./CreateKnowledgeItemView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports